import { useState } from 'react';
import { IconButton, Skeleton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { RootCard, RootCardHeader } from '../../util/SharedStyles';

interface BusinessAreaListItemProps {
    name?: string | undefined;
    id?: string | undefined;
    description?: string | undefined;
    loading?: boolean | false;
    canDelete?: boolean;
    onEditClick: (businessAreaId: string | undefined) => void;
    onDeleteClick: (id: string) => void;
}

const BusinessAreaListItem: React.FC<BusinessAreaListItemProps> = (props: BusinessAreaListItemProps) => {
    const { name, description, loading = false, canDelete = false } = props;
    const businessAreaId = props.id as string;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isMenuOpen = Boolean(anchorEl);

    const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = (event: React.MouseEvent<any>) => {
        let buttonDataSet = (event.target as HTMLElement).dataset;
        
        if (buttonDataSet.operation === "edit") {
            props.onEditClick(businessAreaId);
        }
        else if (buttonDataSet.operation === "delete")
        {
            props.onDeleteClick(businessAreaId);
        }
        setAnchorEl(null);
    };

    let areaAction = loading? undefined: (
        < IconButton
            aria-label="options-button"
            id="options-button"
            onClick={handleMenuClick}
        >
            <MoreVertIcon />
        </IconButton >
    );

    let areaTitle = loading ? (
        <Skeleton animation="wave" height={32} width="50%" />
    ) : (
        name
    );

    let areaSubheader = loading ? (
        <Skeleton animation="wave" height={24} width="30%" />
   ) : (
       description
   );

    return (
        <RootCard>
            <RootCardHeader
                title={areaTitle} 
                subheader={areaSubheader}
                //action prop for adding 3-dot menu options button
                action={areaAction}
            />
            <Menu
                id="card-options-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem
                    data-operation="edit"
                    onClick={handleMenuClose}
                    >
                    Edit
                </MenuItem>
                { canDelete &&
                <MenuItem
                    data-operation="delete"
                    onClick={handleMenuClose}
                    >
                    Delete    
                </MenuItem>
                }
            </Menu> 
        </RootCard>
    );
};

export default BusinessAreaListItem;

